import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, VStack, Heading, AspectRatio, Text } from "@chakra-ui/react";
import { getVideosByCategory } from "../../../services/videoService";
import VideosNavbar from "../../../components/navbars/vdeosNavbar/videosNavbar";

const CategoryPage = () => {
  const { category } = useParams();
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const result = await getVideosByCategory(category);
        if (result) {
          setVideos(result.Items);
        }
      } catch (error) {
        console.error("Error fetching category videos:", error);
      }
    };

    fetchVideos();
  }, [category]);

  return (
    <Box dir="ltr">
      <VideosNavbar>
        <VStack spacing={8} p={4} align="stretch" dir="rtl">
          <Heading size="lg" dir="rtl">
            {category}
          </Heading>
          {videos.length > 0 ? (
            [...videos]
              .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
              .map((video) => {
                let videoId = "";

                // Handle regular YouTube videos
                if (video.url.includes("watch?v=")) {
                  videoId = video.url.split("watch?v=")[1].split("&")[0];
                }
                // Handle YouTube Shorts
                else if (video.url.includes("/shorts/")) {
                  videoId = video.url.split("/shorts/")[1].split("?")[0];
                }

                const embedUrl = `https://www.youtube.com/embed/${videoId}`;

                return (
                  <Box
                    key={video.videoId}
                    bg="white"
                    shadow="md"
                    borderRadius="md"
                    overflow="hidden"
                  >
                    <Heading size="md">{video.title}</Heading>
                    <AspectRatio ratio={16 / 9}>
                      <iframe
                        src={embedUrl}
                        title={video.title}
                        allowFullScreen
                      />
                    </AspectRatio>
                    <Box p={4}>
                      <Text>{video.description}</Text>
                    </Box>
                  </Box>
                );
              })
          ) : (
            <Text color="white">No videos available.</Text>
          )}
        </VStack>
      </VideosNavbar>
    </Box>
  );
};

export default CategoryPage;
